<template>
  <div class="sample_service_check">
    <label class="ss_label">{{ label }}</label>
    <div class="container">
      <el-radio-group v-model="radioList" v-if="type === 'radio'">
        <el-radio-button label="unlimited">不限</el-radio-button>
        <el-radio-button v-for="item of items" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
      </el-radio-group>
      <el-checkbox-group v-model="checkList" v-else>
        <el-checkbox-button label="unlimited">不限</el-checkbox-button>
        <el-checkbox-button v-for="item of items" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox-button>
      </el-checkbox-group>
      <div class="suffix" v-if="showSuffix">
        <slot name="suffix" v-if="$slots.suffix"></slot>
        <span v-else>{{ suffix }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SampleServiceCheck',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    suffix: {
      type: String,
      default: ''
    },
    showSuffix: {
      type: Boolean,
      default: true
    },
    check: {
      type: [Array, String, Number],
      default: () => []
    },
    type: {
      type: String,
      default: 'checkbox'
    }
  },
  model: {
    prop: 'check',
    event: 'change'
  },
  computed: {
    checkList: {
      get() {
        return this.check.length === 0 ? ['unlimited'] : this.check
      },
      set(list) {
        if (list.length === 0) {
          this.$emit('change', [])
        } else {
          const isExistUnlimited = list.includes('unlimited')
          if (isExistUnlimited) {
            const isCEUnlimited = this.check.length === 0 || this.check.includes('unlimited')
            if (isCEUnlimited) {
              this.$emit(
                'change',
                list.filter(f => f !== 'unlimited')
              )
            } else {
              this.$emit('change', [])
            }
          } else {
            this.$emit('change', list)
          }
        }
      }
    },
    radioList: {
      get() {
        const isNil = this.check === '' || this.check === undefined || this.check === null
        return isNil ? 'unlimited' : this.check
      },
      set(val) {
        this.$emit('change', val === 'unlimited' ? '' : val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sample_service_check {
  @apply w-full flex;
  .ss_label {
    @apply pr-4 py-4 box-border whitespace-nowrap text-right text-theme-black-650 text-medium leading-normal font-medium;
    min-width: 90px;
  }
  .container {
    @apply pt-4 pb-2 box-border flex-1 flex items-center justify-between border-t border-dashed border-border-gray;
    @each $type in checkbox, radio {
      ::v-deep .el-#{$type}-group {
        .el-#{$type}-button {
          @apply mb-2 relative;
          .el-#{$type}-button__inner {
            @apply text-theme-black-650 border-d8;
          }
          &:first-child .el-#{$type}-button__inner,
          &:last-child .el-#{$type}-button__inner {
            @apply rounded-none;
          }
          &.is-focus {
            .el-#{$type}-button__inner {
              @apply border-d8;
            }
          }
          &::before {
            content: '';
            @apply absolute top-0 -left-px w-px h-full overflow-hidden;
            border-left: 1px solid #d8d8d8;
          }
          &:first-child {
            &::before {
              content: '';
              display: none;
            }
          }
        }
        .is-active,
        .is-checked {
          &.is-focus {
            .el-#{$type}-button__inner {
              @apply border-theme;
            }
          }
          .el-#{$type}-button__inner {
            @apply text-medium font-normal whitespace-nowrap text-theme border-theme;
            background-color: rgba(39, 117, 232, 0.1);
          }
          & + .el-#{$type}-button::before {
            display: none;
          }
        }
        .el-#{$type}-button__inner {
          @apply px-4 py-1 leading-22 border-d8;
        }
      }
    }
  }
  .suffix {
    @apply text-medium text-theme-black-450 text-right ml-6 mb-2 whitespace-nowrap font-normal;
    min-width: 60px;
  }
}
</style>
